export type CostRow = {
  without: string
  with: string
}

export const costRows: CostRow[] = [
  {
    without: 'Horas buscando recetas que no están adaptadas a Argentina',
    with: '300+ recetas listas. Abrís, elegís, cocinás.',
  },
  {
    without: 'Ingredientes importados que no conseguís en el super',
    with: '100% disponible en cualquier supermercado argentino.',
  },
  {
    without: 'Menús improvisados que generan picos de glucosa inesperados',
    with: '4 semanas de menús organizados y equilibrados. Ya listos.',
  },
  {
    without: 'El asado, las empanadas, los postres: eliminados sin alternativa real',
    with: 'Todo adaptado. Nada eliminado. Mismo sabor, sin el pico.',
  },
  {
    without: 'Sin registro de comidas ni glucosa: sin datos, sin control real',
    with: 'Tracker diario incluido. El control se vuelve visible.',
  },
  {
    without: 'Comer con miedo, con culpa, con angustia en cada plato',
    with: 'Comer con información, con confianza, con placer.',
  },
  {
    without: 'El mismo caos alimentario el año que viene',
    with: 'Un sistema que funciona para siempre.',
  },
]

export type KitRow = {
  situation: string
  without: string
  with: string
}

export const kitRows: KitRow[] = [
  {
    situation: 'El médico pide registro de comidas y glucosa',
    without: 'Anotás en un papel que después no encontrás',
    with: 'Planilla profesional lista. Imprimís y llevás.',
  },
  {
    situation: 'Querés saber si una receta nueva sube o no la glucosa',
    without: 'Buscás info técnica que no entendés',
    with: 'Tabla de índice glucémico por ingrediente. Clara.',
  },
  {
    situation: 'Necesitás adaptar el plan a diabetes tipo 1 o tipo 2',
    without: 'Le preguntás al médico cada vez que dudás',
    with: 'Guía de ajuste por tipo de diabetes. Ya está.',
  },
  {
    situation: 'Cambios de estación: ingredientes que varían',
    without: 'Improvisás con lo que hay y esperás',
    with: 'Plan estacional con ingredientes de temporada.',
  },
  {
    situation: 'Querés ver el progreso real en el tiempo',
    without: 'No tenés forma de verlo claramente',
    with: 'Dashboard mensual. Visual. Concreto.',
  },
]

export const kitChecklist: string[] = [
  'Planilla de registro médico-nutricional lista para llevar al médico',
  'Tabla de índice glucémico de los ingredientes más usados en Argentina',
  'Guía de ajuste por tipo de diabetes (tipo 1 y tipo 2)',
  'Plan estacional de comidas (verano, otoño, invierno y primavera)',
  'Dashboard de seguimiento mensual de glucosa y alimentación',
  'Guía de señales de alerta y cuándo consultar al médico',
]
